import { Allocation, Mandate, MandateTransactions } from "@/types/management-mandate";
import axiosInstance from "./axiosInstance";
import { AxiosResponse } from 'axios';
import { DataLineChart, ParamsChart } from "@/types/common";
import { TransactionFilterParams } from '@/types/filters';
import { cleanFilterParams } from '@/core/utils/filters';

export class MandateService {
  private static readonly GET_LIST_MANDATE = 'app/mandates';
  private static readonly GET_DETAIL_MANDATE = 'app/mandates';
  private static readonly CREATE_MANDATE = 'app/mandates';

  private static readonly GET_INVEST_INFO_USER_CURRENT_ENDPOINT = 'app/users/mandate/invest-profile';
  private static readonly UPDATE_INVEST_INFO_USER_ENDPOINT = 'app/users/mandate/invest-profile';
  private static readonly UPDATE_INVEST_PROFILE_TYPE_ENDPOINT = 'app/users/mandate/invest-profile-type';
  private static readonly UPDATE_MANAGEMENT_PROFILE_ENDPOINT = 'app/users/mandate/management-profile';

  public static async getListMandate(): Promise<Mandate[]> {
    const res: AxiosResponse<Mandate[]> = await axiosInstance.get(MandateService.GET_LIST_MANDATE);
    return res.data;
  }

  public static async getDetailMandate(id: string): Promise<Mandate> {
    const res: AxiosResponse<Mandate> = await axiosInstance.get(`${MandateService.GET_DETAIL_MANDATE}/${id}`);
    return res.data;
  }

  public static async getMandateAllocations(id: string): Promise<Allocation[]> {
    const res: AxiosResponse<Allocation[]> = await axiosInstance.get(`${MandateService.GET_DETAIL_MANDATE}/${id}/allocations`);
    return res.data;
  }

  public static async getMandateTransactions(params: {id: string, offset?: number, limit?: number, filters?: TransactionFilterParams}): Promise<MandateTransactions> {
    const { id, offset = 0, limit = 10, filters } = params;
    const res: AxiosResponse<MandateTransactions> = await axiosInstance.get(`${MandateService.GET_DETAIL_MANDATE}/${id}/transactions`, {
      params: {
        offset,
        limit,
        ...cleanFilterParams(filters),
      }
    });
    return res.data;
  }

  public static async getMandateReport(params: ParamsChart): Promise<DataLineChart> {
    const { id, period } = params;
    const res: AxiosResponse<DataLineChart> = await axiosInstance.get(`${MandateService.GET_DETAIL_MANDATE}/${id}/report`, {
      params: {
        period
      }
    });
    return res.data;
  }

  public static async getInvestInfoUserCurrent(): Promise<Record<string, any>> {
    const res: AxiosResponse<Record<string, any>> = await axiosInstance.get(MandateService.GET_INVEST_INFO_USER_CURRENT_ENDPOINT);
    return res.data;
  }

  public static async updateInvestInfoUser(data: Record<string, any>): Promise<Record<string, any>> {
    const res: AxiosResponse<Record<string, any>> = await axiosInstance.post(MandateService.UPDATE_INVEST_INFO_USER_ENDPOINT, data);
    return res.data;
  }

  public static async updateInvestProfileType(data: Record<string, any>): Promise<Record<string, any>> {
    const res: AxiosResponse<Record<string, any>> = await axiosInstance.post(MandateService.UPDATE_INVEST_PROFILE_TYPE_ENDPOINT, data);
    return res.data;
  }

  public static async updateManagementProfile(data: Record<string, any>): Promise<Record<string, any>> {
    const res: AxiosResponse<Record<string, any>> = await axiosInstance.post(MandateService.UPDATE_MANAGEMENT_PROFILE_ENDPOINT, data);
    return res.data;
  }
}
